import script from "./standDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./standDetail.vue?vue&type=script&setup=true&lang=js"

import "./standDetail.vue?vue&type=style&index=0&id=7c494d0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c494d0e"]])

export default __exports__